export default __webpack_public_path__ + "static/media/6 Mueble en madera archivador.af3a2656.jpeg";